const colors = {
    // Blues
    lightBlue: "#87A6EA",
    spareBlue: "#4C6EF8",
    darkBlue: "#182D86",
  
    // Accent colors
    spareOrange: "#F69300",
    redOrange: "#FF5B3C",
    red: "#C42316",
    pink: "#FFDCD4",
  
    // Backgrounds / neutrals
    white: "#ffffff",
    disabledGray: "#d8d8d884",
    lightGrey: "#ccc",
    grey: "#6c757d",
    darkGrey: "#888",
    black: "#cccccc",
  
    // Success / money
    mint: "#20c997",
    green: "rgb(28, 125, 28)",
  
    // Buttons (resolved aliases)
    action: "#182D86",        // dark-blue
    actionHover: "#4C6EF8",   // spare-blue
  
    edit: "#4C6EF8",          // spare-blue
    editHover: "#87A6EA",     // light-blue
  
    delete: "#C42316",        // red
    deleteHover: "#FFDCD4",   // pink
  
    deactivate: "#FF5B3C",    // red-orange
    deactivateHover: "#F69300"// spare-orange
  };
  
  export default colors;
  